import React from 'react'

import { withRouter, Link } from 'react-router-dom';

import { Container, Button, Grid, Icon, Popup, Label, Segment, Dimmer, Loader } from 'semantic-ui-react';
import { Section, InfosBar, Table, SensorStatus, Text, Firmware, Selection, Empty } from 'components';

import { ModalLinkSensor } from 'modals';

import { Typeof, Functions } from 'utils';

import { API } from 'services';

import { EnumSensorStatus } from 'enums';

import classnames from 'classnames';

import './style.css';

//--Constants
const SENSORS_PER_PAGE = 7;

const LOCATIONS = [
  "head",
  "withers",
  "croup",
  "forelimb_left",
  "forelimb_right",
  "hindlimb_left",
  "hindlimb_right"
];

class PaneSensors extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showSensorLinkModal: false,
      searchCriteria: '',
      isEditing: false,
      isSaving: false,
      configuration: Object.assign({}, props.device.current_configuration)
    };

    this.handleClick = this.handleClick.bind(this);

    this.toggleEdit = this.toggleEdit.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.saveEdit = this.saveEdit.bind(this);

    this.getAvailableSensors = this.getAvailableSensors.bind(this);
    this.renderSensorConfigurator = this.renderSensorConfigurator.bind(this);

    this.getSensor = this.getSensor.bind(this);

    this.toggleSensorLinkModal = this.toggleSensorLinkModal.bind(this);
    this.handleSensorLinkModalClose = this.handleSensorLinkModalClose.bind(this);

    this.handleSensorSearch = this.handleSensorSearch.bind(this);
    this.handleSensorSelect = this.handleSensorSelect.bind(this);
  }

  toggleSensorLinkModal() {

    //Show modal
    this.setState({
      showSensorLinkModal: !this.state.showSensorLinkModal
    });
  }

  handleSensorLinkModalClose(sensor) {

    if(Typeof.string(sensor)) {

      this.props.device.sensors.push(sensor);

      let configuration = this.state.configuration;

      configuration.is_valid = this.isConfigurationValid(configuration);

      this.setState({
        configuration: configuration
      }, () => {

        if(configuration.is_valid) {
          this.props.device.current_configuration.is_valid = configuration.is_valid;

          this.props.onConfigurationSave();
        }
      });
    }

    //Hide modal
    this.toggleSensorLinkModal();
  }

  handleSensorSearch(criteria) {

    this.setState({
      searchCriteria: criteria
    });

  }

  handleSensorSelect(sensor) {

    //Navigate to sensor page
    this.props.history.push(`/sensors/${sensor.mac_address}`);
  }

  toggleEdit(save) {

    this.setState({
      isEditing: true
    });
  }

  cancelEdit() {

    this.setState({
      isEditing: false,
      configuration: Object.assign({}, this.props.device.current_configuration)
    });
  }

  saveEdit() {

    this.setState({
      isSaving: true,
    }, () => {

      API.post(`/devices/${this.props.device.id}/sensors/configurations`, this.state.configuration)
        .then((response) => {

          this.props.device.current_configuration = response.data;

          this.props.onConfigurationSave();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {

          this.setState({
            isSaving: false,
            isEditing: false
          });
        })

    });
  }

  getSensor(macAddress) {
    return this.props.sensors.find((sensor) => sensor.mac_address === macAddress);
  }

  render() {

    const { device } = this.props;
    const sensors = device.sensors.map(this.getSensor);

    let columns = [
      {
        id: 'mac_address',
        header: 'Adresse MAC',
        value: (sensor) => sensor.mac_address,
        render: (sensor, macAddress) => {
          return (
            <Text style={{"mono" : true}}>
              {Functions.formatMacAddress(macAddress)}
            </Text>
          )
        }
      },
      {
        id: 'status',
        header: 'Status',
        value: (sensor) => EnumSensorStatus.name(sensor.status),
        render: (sensor, status) => {
          return <SensorStatus status={sensor.status} />
        },
        sort: (a, b) => {
          return EnumSensorStatus.weight(a.status) - EnumSensorStatus.weight(b.status);
        },
        fit: true
      },
      {
        id: 'firmware',
        header: 'Micrologiciel',
        value: (sensor) => sensor.firmware,
        render: (sensor, firmware) => {
          return <Firmware firmware={firmware} />
        },
        fit: true
      }
    ];

    return (
      <React.Fragment>

        {/* Configuration */}
        <Container>

          <Section collapsible title={<span><Icon name="setting" />Configuration</span>} actions={
            !this.state.isEditing ? (
              <Button icon="edit" onClick={this.toggleEdit} content="Modifier" />
            ) : ([
              <Button icon="save" disabled={!this.state.configuration.is_valid} color="green" onClick={this.saveEdit} content="Enregistrer" />,
              <Button icon="times" color="red" onClick={this.cancelEdit} content="Annuler" />
            ])
          } loading>

            {/* Save loader */}
            <Dimmer.Dimmable blurring dimmed={this.state.isSaving}>

              <Dimmer active={this.state.isSaving} inverted>
                <Loader inverted>Enregistrement...</Loader>
              </Dimmer>

              <Grid centered columns={5}>

                <Grid.Row>

                  {/* Head */}
                  <Grid.Column>
                    {this.renderSensorConfigurator('Tête', 'head')}
                  </Grid.Column>

                </Grid.Row>

                <Grid.Row>

                  {/* Forelimb left */}
                  <Grid.Column>
                    {this.renderSensorConfigurator('Antérieur gauche', 'forelimb_left')}
                  </Grid.Column>

                  {/* Withers */}
                  <Grid.Column>
                    {this.renderSensorConfigurator('Garrot', 'withers')}
                  </Grid.Column>

                  {/* Forelimb right */}
                  <Grid.Column>
                    {this.renderSensorConfigurator('Antérieur droit', 'forelimb_right')}
                  </Grid.Column>

                </Grid.Row>

                <Grid.Row>

                  {/* Hindlimb left */}
                  <Grid.Column>
                    {this.renderSensorConfigurator('Postérieur gauche', 'hindlimb_left')}
                  </Grid.Column>

                  {/* Croup */}
                  <Grid.Column>
                    {this.renderSensorConfigurator('Croupe', 'croup')}
                  </Grid.Column>

                  {/* Hindlimb right */}
                  <Grid.Column>
                    {this.renderSensorConfigurator('Postérieur droit', 'hindlimb_right')}
                  </Grid.Column>

                </Grid.Row>
              </Grid>

            </Dimmer.Dimmable>
          </Section>

        </Container>


        {/* Sensors */}
        <Container>

          <Section title="Capteurs" onSearch={this.handleSensorSearch} actions={[
            <Button icon="add" content="Associer" onClick={this.toggleSensorLinkModal} />
          ]}>

            {sensors.length > 0 ? (

              <React.Fragment>

                {/* Number of available sensor */}
                <InfosBar mode="column">
                  <span>{sensors.length > 1 ? `${sensors.length} capteurs associés` : '1 capteur associé'}</span>
                </InfosBar>

                {/* sensors table */}
                <Table columns={columns}
                  criteria={this.state.searchCriteria}
                  items={sensors}
                  itemsPerPage={SENSORS_PER_PAGE}
                  onSelect={this.handleSensorSelect}
                  messageEmpty="Aucun capteur ne correspond à votre recherche"
                />

              </React.Fragment>

            ) : (

              // No sensor available
              <InfosBar mode="row">
                <span>Aucun capteur disponible</span>
              </InfosBar>

            )}


          </Section>

        </Container>

        {/* Sensor link modal */}
        {this.state.showSensorLinkModal &&
          <ModalLinkSensor onClose={this.handleSensorLinkModalClose} device={device} />
        }

      </React.Fragment>
    );
  }

  handleClick(macAddress, location) {

    let configuration = this.state.configuration;

    if(Typeof.string(macAddress) && macAddress.length > 0) {
      configuration[location] = macAddress;
    } else {
      delete configuration[location]
    }

    configuration.is_valid = this.isConfigurationValid(configuration);

    this.setState({
      configuration: configuration
    });
  }

  isConfigurationValid(configuration) {

    return !LOCATIONS.some((location) => {
      return this.validateSensor(configuration, location).length > 0;
    });
  }

  getAvailableSensors(except) {

    let selected = LOCATIONS.map((location) => this.state.configuration[location])
      .filter((macAddress) => {

        //Undefined
        if(!Typeof.string(macAddress)) {
          return false;
        }

        //Except
        if(Typeof.string(except)) {
          return macAddress !== except;
        }

        return true
      });

    //Get all sensors
    let sensors = this.props.device.sensors;

    //Remove all sensors attributed
    sensors = sensors.filter((macAddress) => {
      if(selected.includes(macAddress)) {
        return false;
      }

      let sensor = this.getSensor(macAddress);

      if(sensor.status !== EnumSensorStatus.OK) {
        return false;
      }

      return true;
    });

    return sensors.map((sensor) => {

      return {
        key: sensor,
        value: sensor,
        text: Functions.formatMacAddress(sensor)
      }
    });
  }

  validateSensor(configuration, location) {

    let selectedSensor = configuration[location];

    //Validate
    let errors = [];

    //Not set
    if (!Typeof.string(selectedSensor)) {
      errors.push("Aucun capteur n'est attribué à cet emplacement");

    } else {

      let sensor = this.getSensor(selectedSensor);

      if(sensor) {

        if(!this.props.device.sensors.includes(selectedSensor)) {
          errors.push("Ce capteur n'est pas associé à cette valise");

        } else {

          //Wrong status
          if (sensor.status !== EnumSensorStatus.OK) {
            errors.push("L'état de ce capteur requiert votre attention");
          }

          //Already used
          if (LOCATIONS.some((other) => configuration[other] === selectedSensor && other !== location)) {
            errors.push("Ce capteur est déjà attribué à un autre emplacement");
          }

        }

      } else {
        errors.push("Capteur inconnu");
      }
    }

    return errors;
  }

  renderSensorConfigurator(title, location) {

    let selectedSensor = this.state.configuration[location];

    //Get available sensors + the one selected
    let availableSensors = this.getAvailableSensors(selectedSensor);

    //Validate
    let errors = this.validateSensor(this.state.configuration, location);
    let isInvalid = errors.length > 0;

    return (
      <Popup pinned disabled={!isInvalid} inverted position="top center"
        trigger={
          <Segment raised color={isInvalid ? "red" : "green"}>

            {isInvalid &&
              <Label as='a' color='red' corner="left" size="mini">
                <Icon name="warning sign" />
              </Label>
            }

            <div className={classnames("sensor-configurator", { "invalid": isInvalid })}>

              {/* Location */}
              <span>
                {title}
              </span>

              {this.state.isEditing ? (
                <Selection scrolling fluid clearable options={availableSensors} value={selectedSensor} onChange={(macAddress) => this.handleClick(macAddress, location)} placeholder="-" noResultsMessage="Aucun capteur disponible"/>
              ) : (

                <span className="mac_address">

                  {Typeof.string(selectedSensor) ? (
                    <Link to={`/sensors/${selectedSensor}`}>{Functions.formatMacAddress(selectedSensor)}</Link>
                  ) : (
                    <Empty />
                  )}

                </span>

              )}

            </div>
          </Segment>
        }
      >

        {/* Errors */}
        <div className="errors">
          {errors.map((error) => <span>{error}</span>)}
        </div>

      </Popup>
    )
  }
}

export default withRouter(PaneSensors);
